import { render, staticRenderFns } from "./VideoPlayerItem.vue?vue&type=template&id=0b87be30"
import script from "./VideoPlayerItem.vue?vue&type=script&lang=js"
export * from "./VideoPlayerItem.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerItem.vue?vue&type=style&index=0&id=0b87be30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports